import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { getApiBaseUrl } from '@services/api.ts';

interface UserAvatarProps extends Omit<AvatarProps, 'src'> {
  path?: string | null;
  name?: string | null;
}

const getFullAvatarUrl = (path: string | undefined | null): string | undefined => {
  if (!path) return undefined;
  if (path.startsWith('http')) return path; // Already a full URL
  const baseUrl = getApiBaseUrl().replace('/api/v1', ''); // Get base URL (e.g., http://localhost:3200)
  return `${baseUrl}/${path}`;
};

export const UserAvatar: React.FC<UserAvatarProps> = ({ path, name, sx, ...props }) => {
  const fullUrl = getFullAvatarUrl(path);

  return (
    <Avatar src={fullUrl} sx={sx} {...props}>
      {fullUrl ? null : (name ? name.charAt(0).toUpperCase() : undefined)}
    </Avatar>
  );
};
